import React from "react";
import { useHistory } from "react-router-dom";
import { ArrowLongLeftIcon } from "@heroicons/react/24/solid";
import { PencilIcon, CheckIcon, XMarkIcon, ArrowPathIcon } from "@heroicons/react/24/outline";
import Button from "./Button";


const Container = ({ children }) => {
  return (
    <div className="container mx-auto px-6 md:px-8">{children}</div>
  );
};

const PageHeading = ({ title, contentActions, historyBackPath = null, onHistoryBackClick = null, titleWrap=true, titleClasses="" }) => {

  const { push } = useHistory();

  return (
    <div className={"py-6 flex items-center justify-stretch gap-x-20 gap-y-6 flex-col sm:flex-row " + (titleWrap ? "flex-wrap" : "")}>
      <div className="flex-1 w-full sm:w-auto">
        <h1 className={`text-3xl font-extrabold leading-7 text-black-500 sm:text-3xl whitespace-nowrap flex gap-4 items-center ${titleClasses}`}>
          {
            !!historyBackPath || !!onHistoryBackClick
              ? <ArrowLongLeftIcon
                  className="inline-block h-9 w-9 cursor-pointer"
                  onClick={() => {
                    if (!!historyBackPath)
                      push(historyBackPath);
                    else if (typeof onHistoryBackClick === "function")
                      onHistoryBackClick();
                  }}
                />
              : null
          }
          <span>{title}</span>
        </h1>
      </div>
      <div className="ml-auto flex flex-wrap gap-2 flex-col w-full sm:flex-row sm:w-auto">{contentActions}</div>
    </div>
  );
};

const renderSectionEditButton = (Icon, text, intl, onClick) => (
  <Button styleType="white" className="flex gap-2 group transition-all" paddingCls="p-2" onClick={onClick}>
    <Icon className="w-4 h-4" />
    {/* <span className="text-xs hidden group-hover:inline">{intl?.formatMessage({id: text}) ?? text}</span> */}
  </Button>
)

const PageSection = ({
    title,
    description,
    children,
    editMode=null,
    onEdit=() => {},
    onConfirm=() => {},
    onCancel=() => {},
    enableSave=true,
    enableCancel=true,
    loading=null,
    intl=null,
}) => (
  <div className="mb-12">
    {title && (
      <>
        <div className="mb-1">
          <div className="space-y-1">
            <h3 className="flex justify-between items-center text-lg leading-6 font-medium text-black-500">
              <span>{title}</span>
              {
                editMode === true
                  ? loading !== true
                    ? (
                      <div className="flex gap-3">
                        {enableSave && renderSectionEditButton(CheckIcon, 'save_edits', intl, onConfirm)}
                        {enableCancel && renderSectionEditButton(XMarkIcon, 'cancel', intl, onCancel)}
                      </div>
                    )
                    : <ArrowPathIcon className="h-4 w-4 animate-spin" aria-hidden="true" />
                  : editMode === false && renderSectionEditButton(PencilIcon, 'edit', intl, onEdit)
              }
            </h3>
            {description && <p className="max-w-2xl text-sm text-gray-500 pb-1">{description}</p>}
          </div>
        </div>
        <div className="mb-5">
          <div className="w-full border-t border-gray-300" />
        </div>
      </>
    )}
    <div className={loading === true ? 'opacity-50 pointer-events-none' : ''}>
      {children}
    </div>
  </div>
);

export default Container;
export { Container, PageHeading, PageSection, renderSectionEditButton };
